import * as React from "react";
import { useLocation, useNavigate } from "react-router";
import NewContractDialog from "../components/NewContractDialog";
import AllgemeinContractCreatePage from "./AllgemeinContractCreatePage";
import ErtragsausfallContractCreatePage from "./ErtragsausfallContractCreatePage";

/** Kategorie-Id des Vertragskatalogs für Ertragsausfall-Deckungen. */
export const ERTRAGSAUSFALL_KATEGORIE_ID = "ertragsausfall-furs-unternehmen";

/**
 * Erkennt Ertragsausfall-/BU-Verträge, für die die eigene Vertragsmaske greift
 * — entweder über die Katalogkategorie oder über den Namen der Vertragsart.
 */
export const isErtragsausfallVertrag = (
  kategorieId?: string | null,
  artName?: string | null,
): boolean =>
  kategorieId === ERTRAGSAUSFALL_KATEGORIE_ID ||
  /ertragsausfall|betriebsunterbrech/i.test(artName ?? "");

/**
 * Route entry for `/vertrag/new`.
 *
 * Drei Modi, entschieden über den Router-State:
 *  - Ertragsausfall-/BU-Vertragsart (Kategorie „Ertragsausfall fürs Unternehmen“)
 *    → eigene Ertragsausfall-Vertragsmaske mit Seitenleiste.
 *  - `state.kontaktId` gesetzt (Kontakt vorausgewählt) **oder**
 *    `state.openAllgemein === true` (Pille „Allgemein Vertrag anlegen“)
 *    → rendere die Allgemein-Vertragsmaske (Stepper, wie KFZ/Immobilie).
 *  - sonst → zeige den Kategorie-Picker (`NewContractDialog`) als Overlay.
 *
 * `state.artName` (z.B. „Inhaltsversicherung“, „Ertragsausfall-Sach“) wird an
 * die Maske durchgereicht und schaltet bei passenden Vertragsarten in den
 * Gefahren-Matrix-Modus.
 */
const NewContractPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state ?? {}) as {
    kontaktId?: number;
    openAllgemein?: boolean;
    artName?: string | null;
    kategorieId?: string | null;
  };
  const hasKontakt = Number.isFinite(state.kontaktId) && Number(state.kontaktId) > 0;

  if (hasKontakt && isErtragsausfallVertrag(state.kategorieId, state.artName)) {
    return <ErtragsausfallContractCreatePage />;
  }

  if (hasKontakt || state.openAllgemein === true) {
    return <AllgemeinContractCreatePage />;
  }

  return <NewContractDialog open onClose={() => navigate(-1)} />;
};

export default NewContractPage;
